import { cn } from '../../lib/utils'

import { Badge } from '../badge'
import { Icon, type IconSize } from '../icon'

export interface MultiplyBadgeProps {
  value: number
  size?: '2xl' | 'xs' | 'sm'
  hideIcon?: boolean
}

export function MultiplyBadge({
  value,
  size = '2xl',
  hideIcon = false,
}: MultiplyBadgeProps) {
  const sizeClass = {
    xs: 'text-2xs',
    sm: 'text-sm',
    '2xl': 'text-2xl',
  }
  const sizeIcon = {
    xs: '2xs',
    sm: 'xs',
    '2xl': 'md',
  }
  return (
    <Badge
      color='custom'
      variant='custom'
      className={cn(
        'bg-multiply-gradient',
        'px-xs flex items-center rounded-full !font-bold text-black-100',
        sizeClass[size],
      )}
    >
      <bdi className='font-sans font-bold'>{value}×</bdi>
      {!hideIcon && <Icon name='Fire' size={sizeIcon[size] as IconSize} />}
    </Badge>
  )
}
